import React from 'react'
import styled from 'styled-components'
import { GifName, gifSrc } from '../../../data/gifs'

// Figma "Ziggie Quiz Avatar": a 56px cream window, with Ziggie's leaf allowed
// HEADROOM above it. Used on the quiz answers and the symptom score.
const SIZE = 56
const RADIUS = 16
const HEADROOM = 5.6
// Figma clips the art to a rounded rectangle that starts this far above the window.
const ART_TOP = -15.8

const Avatar = styled.div`
  position: relative;
  flex-shrink: 0;
  width: ${SIZE}px;
  height: ${SIZE + HEADROOM}px;
  padding-top: ${HEADROOM}px;
  box-sizing: border-box;
`

const Window = styled.div`
  position: relative;
  width: ${SIZE}px;
  height: ${SIZE}px;
  border-radius: ${RADIUS}px;
  background: var(--colour-surface-cream-bold);
`

// Cuts the art off HEADROOM above the window, as the avatar frame does in Figma.
const Headroom = styled.div`
  position: absolute;
  top: -${HEADROOM}px;
  left: 0;
  width: ${SIZE}px;
  height: ${SIZE + HEADROOM}px;
  overflow: hidden;
`

const Clip = styled.div`
  position: absolute;
  top: ${ART_TOP + HEADROOM}px;
  left: 0;
  width: ${SIZE}px;
  height: ${SIZE - ART_TOP}px;
  border-radius: ${RADIUS}px;
  overflow: hidden;
`

// Scale and offset measured against the Figma art: Ziggie's eyes are 23px wide
// and sit 15px in and 27px down from the window's top-left.
const Gif = styled.img`
  position: absolute;
  top: ${-20.4 - ART_TOP}px;
  left: -22.3px;
  width: 95.2px;
  max-width: none;
`

type Props = { gif: GifName }

export const ZiggieAvatar: React.FC<Props> = ({ gif }) => (
  <Avatar>
    <Window>
      <Headroom>
        <Clip>
          <Gif src={gifSrc(gif)} alt="" />
        </Clip>
      </Headroom>
    </Window>
  </Avatar>
)
